import { CalendarState } from "burde";
import { NavigationComponents } from "ui/constants";

export const getComponentByName = (componentName: string) => {
    const component = NavigationComponents.find(
        (x) => x.name === componentName,
    );
    return component !== undefined ? component : null;
};
